import { render } from "./ShippigDetailsPage.vue?vue&type=template&id=a677a9d6"
import script from "./ShippigDetailsPage.vue?vue&type=script&lang=js"
export * from "./ShippigDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__